import { requests } from "../config";
import { IPostLikutData } from "./models/requests";

export const LIKUT = {
  postDataLikut: (data: IPostLikutData) => requests.post(`delivery/18/`, "node", data),
}